
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M103.585 25.013l82.54 49.22a7 7 0 01-3.586 13.013l-18.554-.001V168a8 8 0 01-8 8l-39.525-.001v-34.474c0-8.455-6.77-15.328-15.184-15.497l-.316-.003h-1c-8.56 0-15.5 6.94-15.5 15.5v34.474L44.014 176a8 8 0 01-8-8V87.245l-18.554.001a7 7 0 01-3.586-13.012l82.54-49.221a7 7 0 017.17 0z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    